import { useTranslation } from 'react-i18next';

export default function IndustriesSection() {
  const { t } = useTranslation('common');

  const industries = [
    {
      icon: 'ri-building-line',
      name: t('industries.industry.name'),
      description: t('industries.industry.description')
    },
    {
      icon: 'ri-shopping-bag-line',
      name: t('industries.retail.name'),
      description: t('industries.retail.description')
    },
    {
      icon: 'ri-heart-pulse-line',
      name: t('industries.healthcare.name'),
      description: t('industries.healthcare.description')
    },
    {
      icon: 'ri-government-line',
      name: t('industries.government.name'),
      description: t('industries.government.description')
    }
  ];

  return (
    <section id="industries" className="py-24 lg:py-32 relative">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/78a627228f114a68e878a20237e5938e.jpeg)' }}></div>
      <div className="absolute inset-0 bg-black/70"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="text-sm font-semibold text-[#4d9c71] uppercase tracking-wider mb-4 whitespace-nowrap">
            {t('industries.sectionTitle')}
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('industries.title')}
          </h2>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto">
            {t('industries.subtitle')}
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="text-center group hover:transform hover:scale-105 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border-2 border-[#4d9c71] flex items-center justify-center group-hover:bg-[#4d9c71] transition-all duration-300">
                <i className={`${industry.icon} text-4xl text-[#4d9c71] group-hover:text-white transition-colors duration-300`}></i>
              </div>

              {/* Industry Name */}
              <h3 className="text-2xl font-semibold text-white mb-2">
                {industry.name}
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-sm mb-3">
                {industry.description}
              </p>

              {/* Divider */}
              {index < industries.length - 1 && (
                <div className="hidden lg:block absolute right-0 top-1/2 transform -translate-y-1/2 w-px h-24 bg-gray-600"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
